import { render, staticRenderFns } from "./solutionEarth.vue?vue&type=template&id=2ba16e70&scoped=true&"
import script from "./solutionEarth.vue?vue&type=script&lang=js&"
export * from "./solutionEarth.vue?vue&type=script&lang=js&"
import style0 from "./solutionEarth.vue?vue&type=style&index=0&id=2ba16e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba16e70",
  null
  
)

export default component.exports